import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence, delay } from "framer-motion";
import "./about.scss";
import Header from "../../components/header/Header";
import { message } from "antd";
import { zipImages } from "../../untils/until";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ScreenTip from "../../components/home-screen-tip/ScreenTip"

const IpDetail = () => {
  // const [[currentPage, direction], setPage] = useState([0, 0]); // [当前页码, 方向(1前进/-1后退)]
  const [activeTab, setActiveTab] = useState("part-1"); // 新增状态来跟踪当前活动的标签页
  // const [currentPage, setCurrentPage] = useState(0);
  const [currentIp, setCurrentIp] = useState(0);
  const [direction, setDirection] = useState(0);
  const [scrollY, setScrollY] = useState(0);
  const containerRef = useRef(null);
  const isSwitching = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
    const [mobile, setMobile] = useState(false);
  const { i18n } = useTranslation();

  // 动画配置
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
    },
  };

  const itemVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  const handleNavClick = (type: string, ip: number) => {
    switch (type) {
      case "home":
        navigate("/", { replace: true });
        break;
      case "verse":
        // window.open(`https://${ip}`, "_blank");
        if (ip === -1) {
          navigate("/", { replace: true, state: { page: 1 } });
        } else {
          switch (ip) {
            case 0:
              navigate("/scene?scene=qinghuaci")
              break;
            case 1:
              navigate("/scene?scene=zhongguojie")
              break;
            case 2:
              navigate("/scene?scene=cuojinyin")
              break;
            case 3:
              navigate("/scene?scene=jingtailan")
              break;
            default:
              message.warning("敬请期待");
              break;
          }
        }
        break;
      case "detail":
        if (ip === -1) {
          navigate("/detail", { replace: true, state: { ip: 0 } });
        } else {
          navigate("/detail", { replace: true, state: { ip: ip } });
        }
        break;
      case "about":
        // message.success("跳转我们");
        break;
    }
  };

  const jump = () => {
    window.open("https://www.polycac.com.cn", "_blank");
  };

    useEffect(() => {
      setMobile(typeof window.orientation !== "undefined" ||
        navigator.userAgent.indexOf("IEMobile") !== -1 ||
        navigator.userAgent.indexOf("iPhone") !== -1 ||
        (navigator.userAgent.indexOf("Android") !== -1 &&
          navigator.userAgent.indexOf("Mobile") !== -1) ||
        navigator.userAgent.indexOf("BlackBerry") !== -1 ||
        navigator.userAgent.indexOf("Opera Mini") !== -1);
    }, [])
  

  return (
    <div
      ref={containerRef}
      style={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <Header onNavClick={handleNavClick} activeTab={activeTab} />{" "}
      {/* 将活跃标签页传递给Header */}
      {mobile && <ScreenTip />}
      {/* 页面容器 */}
      <AnimatePresence mode={"popLayout"} custom={direction} initial={true}>
        <div
          className="page-container"
          style={{
            backgroundImage: `url(${zipImages(
              "https://oss.tnworld.cn/eastern/assets/home/home-bg.jpg"
            )})`,
          }}
        >
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="about"
          >
            <div className="bg-cover"></div>
            <motion.div variants={itemVariants} className="about-content">
              <img
                src={zipImages(
                  "https://oss.tnworld.cn/eastern/assets/logo1.png"
                )}
                alt=""
              />
              <div className="about-title">{i18n.t('about_title')}</div>
              <div className="about-text">
                {i18n.t('about_text1')}
              </div>
              <div className="about-text">
                {i18n.t('about_text2')}
              </div>
              <div className="about-text">
                {i18n.t('about_text3')}
              </div>
              <div
                className="btn"
                onClick={() => jump()}
                style={
                    i18n.language === 'en'? {
                      width: '50%',
                      aspectRatio: "174 /38",
                      backgroundImage: `url(${zipImages(
                    "https://oss.tnworld.cn/eastern/assets/btn-bg.png"
                  )})`,
                    }:{
                      backgroundImage: `url(${zipImages(
                    "https://oss.tnworld.cn/eastern/assets/btn-bg.png"
                  )})`,
                    }
                  }
              >
                {i18n.t('about_jump')}
              </div>
            </motion.div>

            <div
              id="water-bottom"
              className="water water-bottom filter-active flow-active"
            ></div>
            <svg width="0" height="0">
              <filter id="water-filter">
                <feTurbulence
                  id="feTurb"
                  type="fractalNoise"
                  baseFrequency="0.01 0.01"
                  seed="7"
                  numOctaves="2"
                />
                <animate
                  xlinkHref="#feTurb"
                  attributeName="baseFrequency"
                  dur="120s"
                  values="0.008 0.20;0.008 0.02"
                  keyTimes="0;1"
                  calcMode="linear"
                  repeatCount="indefinite"
                />
                <feDisplacementMap id="feDisp" in="SourceGraphic" scale="150" />
              </filter>
            </svg>
          </motion.div>
        </div>
      </AnimatePresence>
    </div>
  );
};

export default IpDetail;
